// Exaxmples of usage:
//* 1. In a background image: <div style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}>...
//* 2. In img tag: <img src={toAbsoluteUrl('/media/avatars/300-2.jpg')} />

const toAbsoluteUrl = pathname => {
  // Nếu pathname bắt đầu bằng http hoặc // thì giữ nguyên
  if (pathname.startsWith('http') || pathname.startsWith('//')) {
    return pathname;
  }

  // Lấy base URL từ env hoặc mặc định là '/'
  const baseUrl = import.meta.env.BASE_URL || '/';
  
  // Đảm bảo pathname bắt đầu bằng '/'
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  
  // Kết hợp baseUrl và pathname
  return `${baseUrl}${normalizedPath}`.replace(/\/+/g, '/');
};

export { toAbsoluteUrl };